// The public "Beágyazási hibák" page (/embedding-problems): every message the
// fit-check button (embedded-app app/button.js CONFIG_MSG, app/shared.js
// popupBlocked) or the portal shows about the embed, what it means and the
// numbered fix. The quoted texts are the button's own; keep them in step.
//
// `?code=KEY_NOT_FOUND` (any of `codes`, case-insensitive) opens and
// highlights that entry. Steps that need the portal link into the dashboard;
// signed out, that goes through /login?next=… (config/returnTo.js).

/// No support address in the portal's config (only sales@ for sales), so the
/// general one.
export const SUPPORT_EMAIL = 'hello@outfino.io';

const SETTINGS = '/dashboard/embedded-settings';
const DOMAIN = '/dashboard/embedded-settings#embed-domain';

// where: 'frame' (in place of the button) | 'portal' (on Beállítások) | null (a symptom)
// link: { step, to (a dashboard path) | href, label (i18n key) }
export const PROBLEMS = [
  { code: 'DOMAIN_NOT_SET', codes: ['domain_not_set'], where: 'frame', steps: 3, link: { step: 1, to: DOMAIN, label: 'problems.link.domain' } },
  { code: 'KEY_NOT_ALLOWED', codes: ['domain_mismatch', 'key_not_allowed', 'other_shop'], where: 'frame', steps: 3, link: { step: 1, to: DOMAIN, label: 'problems.link.domain' } },
  { code: 'BRAND_INACTIVE', codes: ['brand_inactive'], where: 'frame', steps: 3, causes: true, link: { step: 1, to: '/dashboard/billing', label: 'problems.link.billing' }, link2: { step: 2, to: '/dashboard/drops', label: 'problems.link.drops' } },
  { code: 'KEY_NOT_FOUND', codes: ['invalid_key', 'key_not_found', 'unknown_key'], where: 'frame', steps: 3, causes: true, link: { step: 1, to: SETTINGS, label: 'problems.link.settings' } },
  { code: 'MISSING_KEY', codes: ['missing_key', 'no_key'], where: 'frame', steps: 3, link: { step: 1, to: SETTINGS, label: 'problems.link.settings' } },
  { code: 'POPUP_BLOCKED', codes: ['popup', 'popup_blocked'], where: 'frame', steps: 3 },
  { code: 'NOT_SEEN', codes: ['not_seen', 'not_configured'], where: 'portal', steps: 3, link: { step: 3, to: SETTINGS, label: 'problems.link.settings' } },
  { code: 'SHOPIFY_NOT_SHOWN', codes: ['shopify', 'shopify_block'], where: null, steps: 3 },
  { code: 'UNKNOWN', codes: ['unknown', 'error'], where: null, steps: 3, link: { step: 3, href: `mailto:${SUPPORT_EMAIL}`, label: 'problems.link.mail' } },
];

/// `?code=` (or `#code`) → the entry's code, or null.
export function problemFor(raw) {
  const v = String(raw || '').trim().replace(/^#/, '').toLowerCase();
  if (!v) return null;
  const hit = PROBLEMS.find((p) => p.code.toLowerCase() === v || p.codes.includes(v));
  return hit ? hit.code : null;
}
